const ITEM_TYPE = "ITEM_TYPE";

export default ITEM_TYPE;